// 基础
import Cookies from 'js-cookie'
import config from '@/config'
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
export const TOKEN_KEY = 'mentor-token'
export const USER_AVATOR = 'mentor-avatar'
export const USER_FILL_MORE = 'menter-fill-more'
export const USER_PAYMENT_INFO = 'menter-payment-info'
// 设置token
export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 })
}
// 删除token
export const removetToken = () => {
  Cookies.remove(TOKEN_KEY)
}
// 获取token
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}
// 设置头像
export const setUserAvatar = data => {
  Cookies.set(USER_AVATOR, data, { expires: config.cookieExpires || 1 })
}
// 获取用户头像
export const getUserAvatar = () => {
  let userAvatar = Cookies.get(USER_AVATOR)
  if (
    !userAvatar ||
    userAvatar === 'undefined' ||
    userAvatar === 'null' ||
    userAvatar === 'false'
  ) {
    userAvatar = MentorAvatar
  }
  return userAvatar
}
// 设置- 基本信息- 是否填完
export const setFillMore = data => {
  Cookies.set(USER_FILL_MORE, data, { expires: config.cookieExpires || 1 })
}
// 获取- 基本信息- 是否填完
export const getFillMore = () => {
  let fillMore = Cookies.get(USER_FILL_MORE)
  let data = true
  if (!fillMore || fillMore === 'undefined' || fillMore === 'false') {
    data = false
  }
  return data
}
// 设置 - 是否填完payment
export const setPaymentInfo = data => {
  Cookies.set(USER_PAYMENT_INFO, data, { expires: config.cookieExpires || 1 })
}
//  获取- 基本信息- 是否填完
export const getPaymentInfo = () => {
  const paymentInfo = Cookies.get(USER_PAYMENT_INFO)
  let data = true
  if (!paymentInfo || paymentInfo === 'undefined' || paymentInfo === 'false') {
    data = false
  }
  return data
}
